module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_c('span', {
    attrs: {
      "id": "page-header"
    }
  }, [_vm._v(_vm._s(_vm.pageheader))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-lg-12"
  }, [_vm._v("Allgemeine Informationen  "), _c('router-link', {
    staticClass: "btn btn-primary create-new pull-right",
    attrs: {
      "to": "/roles/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "customer-information"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.name),
      expression: "model.model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "firstname",
      "name": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.name = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveRole()
      }
    }
  }, [_vm._v("Speichern")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs responsive-tabs"
  }, [_vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.model.id > 0),
      expression: "model.model.id > 0"
    }],
    attrs: {
      "href": "#users"
    }
  }, [_vm._v("Benutzer")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-lg-12"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "addresses"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Dashboard")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "dashboard",
    on: {
      "callback": function($event) {
        _vm.changeIndex('dashboard')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.dashboard),
      callback: function($$v) {
        _vm.model.model.permissionsValues.dashboard = $$v
      },
      expression: "model.model.permissionsValues.dashboard"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Verstorbene")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "deceaseds",
    on: {
      "callback": function($event) {
        _vm.changeIndex('deceaseds')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.deceaseds),
      callback: function($$v) {
        _vm.model.model.permissionsValues.deceaseds = $$v
      },
      expression: "model.model.permissionsValues.deceaseds"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kunden")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "customers",
    on: {
      "callback": function($event) {
        _vm.changeIndex('customers')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.customers),
      callback: function($$v) {
        _vm.model.model.permissionsValues.customers = $$v
      },
      expression: "model.model.permissionsValues.customers"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gräber")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "graves",
    on: {
      "callback": function($event) {
        _vm.changeIndex('graves')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.graves),
      callback: function($$v) {
        _vm.model.model.permissionsValues.graves = $$v
      },
      expression: "model.model.permissionsValues.graves"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Flächen")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "areas",
    on: {
      "callback": function($event) {
        _vm.changeIndex('areas')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.areas),
      callback: function($$v) {
        _vm.model.model.permissionsValues.areas = $$v
      },
      expression: "model.model.permissionsValues.areas"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Krematorien")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "crematories",
    on: {
      "callback": function($event) {
        _vm.changeIndex('crematories')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.crematories),
      callback: function($$v) {
        _vm.model.model.permissionsValues.crematories = $$v
      },
      expression: "model.model.permissionsValues.crematories"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bestatter")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "undertakers",
    on: {
      "callback": function($event) {
        _vm.changeIndex('undertakers')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.undertakers),
      callback: function($$v) {
        _vm.model.model.permissionsValues.undertakers = $$v
      },
      expression: "model.model.permissionsValues.undertakers"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Benutzerverwaltung")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "users",
    on: {
      "callback": function($event) {
        _vm.changeIndex('users')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.users),
      callback: function($$v) {
        _vm.model.model.permissionsValues.users = $$v
      },
      expression: "model.model.permissionsValues.users"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Rollen")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "roles",
    on: {
      "callback": function($event) {
        _vm.changeIndex('roles')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.roles),
      callback: function($$v) {
        _vm.model.model.permissionsValues.roles = $$v
      },
      expression: "model.model.permissionsValues.roles"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Flächenarten")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "area_categories",
    on: {
      "callback": function($event) {
        _vm.changeIndex('area_categories')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.area_categories),
      callback: function($$v) {
        _vm.model.model.permissionsValues.area_categories = $$v
      },
      expression: "model.model.permissionsValues.area_categories"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Grabarten")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "grave_categories",
    on: {
      "callback": function($event) {
        _vm.changeIndex('grave_categories')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.grave_categories),
      callback: function($$v) {
        _vm.model.model.permissionsValues.grave_categories = $$v
      },
      expression: "model.model.permissionsValues.grave_categories"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bestattungsarten")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "burial_types",
    on: {
      "callback": function($event) {
        _vm.changeIndex('burial_types')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.burial_types),
      callback: function($$v) {
        _vm.model.model.permissionsValues.burial_types = $$v
      },
      expression: "model.model.permissionsValues.burial_types"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Konfessionen")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "denominations",
    on: {
      "callback": function($event) {
        _vm.changeIndex('denominations')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.denominations),
      callback: function($$v) {
        _vm.model.model.permissionsValues.denominations = $$v
      },
      expression: "model.model.permissionsValues.denominations"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Friedhofsverwaltung")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "graveyards",
    on: {
      "callback": function($event) {
        _vm.changeIndex('graveyards')
      }
    },
    model: {
      value: (_vm.model.model.permissionsValues.graveyards),
      callback: function($$v) {
        _vm.model.model.permissionsValues.graveyards = $$v
      },
      expression: "model.model.permissionsValues.graveyards"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.model.id > 0),
      expression: "model.model.id > 0"
    }],
    staticClass: "tab-pane",
    attrs: {
      "id": "users"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.userCols,
      "src-model": _vm.model.users,
      "add": "",
      "delete": "",
      "select": "/users/{:id}",
      "nosort": ""
    },
    on: {
      "add": function($event) {
        _vm.addRelation('users')
      },
      "delete": _vm.deleteUser
    }
  })], 1)])])])])])])]), _vm._v(" "), (_vm.visibleModal === 'addusers') ? _c('custom-modal', {
    attrs: {
      "title": "Benutzer auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "select": "",
      "src-model": _vm.$store.getters.models('users'),
      "cols": _vm.superiorSearchCols,
      "store": "users",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "select": _vm.pickUser
    }
  })], 1)])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "href": "/roles/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "href": "/roles/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#addresses"
    }
  }, [_vm._v("Berechtigungen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Bereich")]), _vm._v(" "), _c('th', [_vm._v("Berechtigungsstufe")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-690ca2ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RoleEdit.vue
// module id = 453
// module chunks = 0